export function podeAcessar(caminho) {
  const perfil = JSON.parse(localStorage.getItem("perfilUsuario") || "[]");
  const item = perfil.find(p => p.caminho === caminho);
  return item && item.permissao_ver === "S";
}

export function podeInserir(caminho) {
  const perfil = JSON.parse(localStorage.getItem("perfilUsuario") || "[]");
  const item = perfil.find(p => p.caminho === caminho);
  return item && item.permissao_inserir === "S";
}

export function podeEditar(caminho) {
  const perfil = JSON.parse(localStorage.getItem("perfilUsuario") || "[]");
  const item = perfil.find(p => p.caminho === caminho);
  return item && item.permissao_editar === "S";
}

export function podeExcluir(caminho) {
  const perfil = JSON.parse(localStorage.getItem("perfilUsuario") || "[]");
  const item = perfil.find(p => p.caminho === caminho);
  return item && item.permissao_excluir === "S";
}

export function podeImprimir(caminho) {
  const perfil = JSON.parse(localStorage.getItem("perfilUsuario") || "[]");
  const item = perfil.find(p => p.caminho === caminho);
  return item && item.permissao_imprimir === "S";
}